<template>
	<div id="app">

		<Nav style="position :fixed;top:0; width: 100%;z-index: 999; " :gourl="gourl">
		</Nav>

		<service>
		</service>
		<div class="zhangao"></div>

		<router-view></router-view>
		<Pagefoot style="z-index: 999;"></Pagefoot>
	</div>
</template>

<script>
	import Nav from './components/nav.vue'
	import service from './components/service.vue'
	import Pagefoot from './components/pagefoot.vue'
	export default {
		name: 'app',
		components: {
			Nav,
			Pagefoot,
			service
		},
		data() {
			return {
				model: "black",
				// stylemodel:"1"
				gourl: "",
				pageindex: 0,
			}
		},
		gopage: function(url) {
			this.gourl = url;
		}
	}
</script>

<style>
	#app {
		font-family: Microsoft YaHei-Bold, Microsoft YaHei;
		font-size: 14px;
		line-height: 1.42857143;
		color: #333333;

	}




	@media (min-width: 1px) {
		.zhangao {
			 height: 80px;
	
		}
	}
	
	@media (min-width: 1000px) {
		.zhangao {
		 height: 0px;
	
		}
	}
	



	.paddingview {
		padding-top: 30px;
		padding-bottom: 30px;
	}



	/* 定位 */

	.flexspacebetween {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-self: flex-start;
	}

	.flexcenter {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}

	.alignitemscenter {
		align-items: center;
	}

	.flexrowreverse {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-content: space-around;

	}

	.cc {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;

		justify-content: center;
		-ms-justify-content: center;
		align-items: center;
		-ms-align-items: center;
	}

	/* 字体 */
	@font-face {
		font-family: "YouSheBiaoTiHei";
		src: url('./assets/font/YouSheBiaoTiHei-2.ttf'),
			url('./assets/font/YouSheBiaoTiHei-2.ttf'),
			url('./assets/font/YouSheBiaoTiHei-2.ttf');
		/*IE9*/
	}

	/*  ======================颜色====================== */
	.colorfff {
		color: #FFFFFF;
	}

	/* ======================其他======================*/
	.boxshadow {
		box-shadow: 0px 3px 26px 1px rgba(0, 0, 0, 0.16);
	}

	.line-clamp1 {
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*！autoprefixer: off */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		/*！autoprefixer: on */
		overflow: hidden;
	}


	.line-clamp2 {
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*！autoprefixer: off */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		/*！autoprefixer: on */
		overflow: hidden;
	}

	.line-clamp3 {
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*！autoprefixer: off */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		/*！autoprefixer: on */
		autoprefixer: off;
		overflow: hidden;
	}

	.line-clamp5 {
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*！autoprefixer: off */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		/*！autoprefixer: on */
		autoprefixer: off;
		overflow: hidden;
	}
</style>
